var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0265 16.12H2.78843C1.73646 16.12 0.883667 15.2672 0.883667 14.2152V2.7038C0.928056 1.68432 1.76798 0.880933 2.78843 0.881898H18.0265C19.0785 0.881898 19.9313 1.73469 19.9313 2.78666V14.2152C19.9313 15.2672 19.0785 16.12 18.0265 16.12ZM2.78843 4.56571V14.2152H18.0265V4.56571L10.4075 9.6438L2.78843 4.56571ZM3.55033 2.78666L10.4075 7.35809L17.2646 2.78666H3.55033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.8ff284637d12cfe4c8b7084dcc4dc21c.svg";
export { ForwardRef as ReactComponent };